import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AdmissionDate from '../common/AdmissionDate';
import { ADMISSION_CONFIG } from '@/constants/admissionConfig';

const AdmissionBadge: React.FC = () => {
    const [mounted, setMounted] = useState(false);
    const [isAdmissionOpen, setIsAdmissionOpen] = useState(false);

    useEffect(() => {
        setMounted(true);
        if (ADMISSION_CONFIG.deadlineFull) {
            // Normalize date string (capitalize first letter of month) for better browser support
            const normalizedDate = ADMISSION_CONFIG.deadlineFull.charAt(0).toUpperCase() +
                ADMISSION_CONFIG.deadlineFull.slice(1);
            const deadline = new Date(normalizedDate).getTime();
            const now = new Date().getTime();
            if (!isNaN(deadline)) {
                setIsAdmissionOpen(deadline > now);
            }
        }
    }, []);

    if (!mounted || !isAdmissionOpen) {
        return null;
    }
    return (
        <div className="admission-badge-fixed">
            <Link href="/admission" className="badge-wrapper">
                <div className="rotating-text-wrapper">
                    <svg viewBox="0 0 200 200" className="rotating-svg">
                        <path
                            id="circlePath"
                            d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
                            fill="transparent"
                        />
                        <text className="rotating-text">
                            <textPath href="#circlePath" startOffset="0%">
                                ADMISSION OPEN FOR <AdmissionDate asFragment /> • ADMISSION OPEN FOR <AdmissionDate asFragment /> • ADMISSION OPEN FOR <AdmissionDate asFragment /> •
                            </textPath>
                        </text>

                    </svg>
                </div>
                <div className="badge-center">
                    <span className="apply-now-text">Apply<br />Now</span>
                </div>
            </Link>
        </div>
    );
};

export default AdmissionBadge;

